export default __webpack_public_path__ + "static/media/PrivateEvents4.560a6c60.jpg";